// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".screenings-submissions .utils-bar{display:flex;flex:1 1 auto;align-items:baseline;justify-content:flex-end;gap:50px}.screenings-submissions .filter-bar .filter-bar__wrapper{display:flex;justify-content:space-evenly;gap:16px}.screenings-submissions .filter-bar .filter-bar__wrapper .ui-filter{margin-right:5px}.screenings-submissions .form-name{flex:3 1 30%}.screenings-submissions .dropdown-menu{min-width:156px}.screenings-submissions .dropdown-menu .ui-button{height:36px}", ""]);
// Exports
module.exports = exports;
